import produce from 'immer';
import {
  GET_SELLERS,
  GET_SELLERS_SUCCESS,
  GET_SELLERS_FAILED,
  UPDATE_SELLER_STATUS,
  UPDATE_SELLER_STATUS_FAILED,
  UPDATE_SELLER_STATUS_SUCCESS,
  CREATE_SELLER,
  CREATE_SELLER_SUCCESS,
  CREATE_SELLER_FAILED,
} from './constants';
import {Actions, State} from './interfaces';

export const initialState: State = {
  sellerList: [],
  loading: false,
  count: 0,
  error: '',
  inactiveCardCount: 0,
  activeCardCount: 0,
};

export const SellerReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_SELLERS:
        draft.loading = true;
        break;
      case GET_SELLERS_SUCCESS:
        // @ts-ignore
        draft.sellerList = action.data;
        draft.count = action.count;
        draft.inactiveCardCount = action.inactiveCardCount;
        draft.activeCardCount = action.activeCardCount;
        draft.loading = false;
        break;
      case GET_SELLERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      case UPDATE_SELLER_STATUS:
        draft.loading = true;
        break;
      case UPDATE_SELLER_STATUS_SUCCESS:
        draft.loading = false;
        break;
      case UPDATE_SELLER_STATUS_FAILED:
        draft.loading = false;
        break;
      case CREATE_SELLER:
        draft.loading = true;
        break;
      case CREATE_SELLER_SUCCESS:
        draft.loading = false;
        break;
      case CREATE_SELLER_FAILED:
        draft.loading = false;
        break;
      default:
        break;
    }
  });

export default SellerReducer;
